import { css } from '@emotion/react'
import { Heading, Text } from 'bold-ui'
import { LoadingIndicator } from 'components/loading'
import { useProntuarioFamiliarVisitasDomiciliaresQuery } from 'graphql/hooks.generated'
import { DesfechoVisitaEnum } from 'graphql/types.generated'

import { ProntuarioFamiliarVisitaDomiciliarCard } from './ProntuarioFamiliarVisitaDomiciliarCard'

interface ProntuarioFamiliarVisitasListSectionProps {
  imovelId: ID
}

export const ProntuarioFamiliarVisitasListSection = ({ imovelId }: ProntuarioFamiliarVisitasListSectionProps) => {
  const { data, loading } = useProntuarioFamiliarVisitasDomiciliaresQuery({
    variables: {
      input: {
        imovelId: imovelId,
        desfecho: DesfechoVisitaEnum.VISITA_REALIZADA,
        pageParams: {
          size: 3,
        },
      },
    },
    skip: !imovelId,
  })
  const hasVisitas = data?.visitas?.content.length > 0
  const visitas = hasVisitas && data.visitas.content

  return (
    <>
      <Heading
        level={4}
        style={css`
          margin-bottom: 0.5rem;
        `}
      >
        Últimas visitas
      </Heading>
      {loading ? (
        <LoadingIndicator />
      ) : hasVisitas ? (
        visitas.map((visita) => <ProntuarioFamiliarVisitaDomiciliarCard visita={visita} key={visita.id} />)
      ) : (
        <Text component='i'>Ainda não existem visitas associadas a esta família</Text>
      )}
    </>
  )
}
